<template>
  <fragment>
    <v-card-text class="nuclear-content" id="team">
      <v-card flat="flat" class="card">
        <v-card-title>
          My Teams
          <div class="dropicon">
            <font-awesome-icon
              :class="this.showmyteams ? 'down-arrow show' : 'down-arrow hide'"
              icon="chevron-down"
              @click="ShowMyTeams"
            />
          </div>
        </v-card-title>
        <v-card-text v-if="this.showmyteams == true">
          <v-row class="myteam" v-if="profile.role == 1">
            <v-col cols="12" sm="5" md="3" lg="3" class="mobile">
              <p class="bold">TEAM</p>
              <v-autocomplete
                v-model="teamManager"
                label="Team Name"
                :rules="fieldRules"
                :items="adminteams"
                item-text="name"
                item-value="id"
                return-object
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3" lg="3" class="mobile adminuser">
              <div class="admin">
                <p class="bold">TEAM ADMIN</p>
                <p v-if="teamManager.users.length > 0">
                  {{ teamManager.users[0].username }}
                </p>
              </div>
              <div class="users">
                <p class="bold">USERS</p>
                <p>{{ teamManager.users.count }}</p>
              </div>
            </v-col>
            <v-col cols="12" sm="9" md="6" lg="6" class="tablet_desktop">
              <v-row class="non_border">
                <v-col cols="12" sm="6" md="6" lg="6" class="team">
                  <p class="bold">TEAM</p>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="center">
                  <p class="bold">TEAM ADMIN</p>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="center">
                  <p class="bold">USERS</p>
                </v-col>
              </v-row>
              <v-row class="border">
                <v-col cols="12" sm="6" md="6" lg="6" class="team">
                  <v-autocomplete
                    v-model="teamManager"
                    label="Team Name"
                    :rules="fieldRules"
                    :items="adminteams"
                    item-text="name"
                    item-value="id"
                    return-object
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="center">
                  <p v-if="teamManager.users.length > 0">
                    {{ teamManager.users[0].username }}
                  </p>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="center">
                  <p>{{ teamManager.users.length }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2" class="team_action">
              <delete-team v-bind:team_id="teamManager.id"></delete-team>
              <invite-users v-bind:team_id="teamManager.id"></invite-users>
            </v-col>
            <create-team></create-team>
          </v-row>
          <v-row class="myteam" v-else>
            <create-team></create-team>
            <v-col cols="12" sm="5" md="2" lg="2" v-if="profile.team.id != ''">
              <invite-users v-bind:team_id="profile.team.id"></invite-users>
            </v-col>
            <v-col cols="12" sm="5" md="2" lg="2" v-if="profile.team.id != ''">
              <delete-team v-bind:team_id="profile.team.id"></delete-team>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-text class="useraccount">
      <div>
        <div class="button_group" v-if="profile.role == 10">
          <div class="alluser_btn">
            <v-btn
              :class="this.showallusers ? 'active_btn' : 'default_btn'"
              @click="ShowAllUsers"
              >All Users</v-btn
            >
          </div>
          <div class="activeteam_btn">
            <v-btn
              :class="this.showactiveteam ? 'active_btn' : 'default_btn'"
              @click="ShowActiveTeam"
              >Active Team</v-btn
            >
          </div>
        </div>
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="12" sm="5" md="5" lg="5" class="account"
                >User Account Provisioning</v-col
              >
              <v-col cols="12" sm="4" md="4" lg="4" class="managers"
                >-Cyber Security Managers-</v-col
              >
              <v-col cols="12" sm="3" md="3" lg="3" class="controls">
                <div class="search_control">
                  <font-awesome-icon class="search_icon" icon="search" />
                  <input
                    type="text"
                    placeholder="Search User"
                    v-model="search"
                  />
                </div>
                <div class="dropicon">
                  <font-awesome-icon
                    class="down-arrow"
                    icon="chevron-down"
                    @click="ShowTableControl"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text v-if="this.showallusers == true">
            <v-row class="table_control" v-if="this.showtablecontrol == true">
              <v-col cols="12" sm="3" md="3" lg="3">
                <v-autocomplete
                  v-model="bulkaction"
                  label="Bulk actions"
                  :rules="fieldRules"
                  :items="bulkactions"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" md="1" lg="1" class="control_button">
                <v-btn color="white" @click="bulkCommit">COMMIT</v-btn>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3">
                <v-autocomplete
                  v-model="assginteam"
                  label="Choose a team"
                  @change="chooseError=false"
                  item-value="id"
                  item-text="name"
                  return-object
                  :items="adminteams"
                  :error="chooseError"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" md="1" lg="1" class="control_button">
                <v-btn color="white" @click="assignTeam">ASSIGN</v-btn>
              </v-col>
              <v-col cols="12" sm="2" md="3" lg="3">
                <v-autocomplete
                  v-model="sortBy"
                  label="Sort by"
                  :rules="fieldRules"
                  :items="sortbyOptions"
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-data-table
              v-model="selected"
              :single-select="singleSelect"
              :headers="headers"
              :items="allusers"
              :hide-default-header="true"
              :hide-default-footer="true"
              :single-expand="singleExpand"
              :search="search"
              :expanded.sync="expanded"
              :disable-pagination="true"
              :sort-by="sortBy"
              item-key="id"
              show-expand
              show-select
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length - 1">
                  <v-row>
                    <v-col cols="12" sm="3" md="2" lg="2">
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold">Company</span
                            ><span>{{ item.company }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold">Title</span
                            ><span>{{ item.title }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="18" md="8" lg="8">
                          <div class="expanded_item regular">
                            <v-autocomplete
                              v-model="item.role"
                              label="regular user"
                              :rules="fieldRules"
                              :items="users"
                              required
                              :disabled="profile.role != 1"
                              @change="changeUserRole(item)"
                            ></v-autocomplete>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="9" md="6" lg="6">
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold address">Address</span
                            ><span>{{ item.address }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4">
                          <div class="expanded_item">
                            <span class="bold">Language</span
                            ><span class="language">{{
                              item.language.name
                            }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="8">
                          <div class="expanded_item">
                            <span class="bold">Timezone</span
                            ><span>{{ item.timezone.name }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold">Gender</span>
                            <span v-if="item.gender == 0">Male</span>
                            <span v-else-if="item.gender == 1">Female</span>
                            <span v-else>Unspecified</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-row>
                        <v-col cols="12" sm="3" md="6" lg="6" class="change">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="hashtag"
                            />
                            <span
                              class="action"
                              @click="
                                userpwdchangestatus = { status: 0, text: '' };
                                userpwdchangedialog = true;
                              "
                              >change password</span
                            >
                          </div>

                          <v-dialog
                            v-model="userpwdchangedialog"
                            max-width="500px"
                          >
                            <v-card class="modal">
                              <v-card-title>
                                <span class="headline">Change Password</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <v-form
                                    v-model="changeUserPwdFormValid"
                                    ref="changeUserPwdForm"
                                    lazy-validation
                                  >
                                    <v-text-field
                                      v-model="usernewpwd"
                                      label="New Password"
                                      type="password"
                                      :rules="passwordRules"
                                      required
                                    ></v-text-field>

                                    <v-text-field
                                      v-model="usernewpwdconfirm"
                                      label="Confirm New Password"
                                      type="password"
                                      :rules="passwordRules"
                                      required
                                    ></v-text-field>

                                    <div class="mt-5">
                                      <p
                                        style="color: red"
                                        v-if="userpwdchangestatus.status == -1"
                                      >
                                        {{ userpwdchangestatus.text }}
                                      </p>
                                      <p
                                        style="color: #2bb9aa"
                                        v-if="userpwdchangestatus.status == 1"
                                      >
                                        {{ userpwdchangestatus.text }}
                                      </p>
                                    </div>
                                  </v-form>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  class="save"
                                  text
                                  @click="changeUserPwd(item)"
                                  >Change</v-btn
                                >
                                <v-btn
                                  class="cancel"
                                  text
                                  @click="userpwdchangedialog = false"
                                  >Cancel</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="pause"
                            />
                            <span
                              class="action"
                              v-if="item.is_active == true"
                              @click="pauseAccount(item)"
                              >pause account</span
                            >
                            <span
                              class="action"
                              v-else
                              @click="pauseAccount(item)"
                              >resume account</span
                            >
                          </div>
                        </v-col>
                        <!-- <v-col
                          cols="12"
                          sm="3"
                          md="6"
                          lg="6"
                          class="remove"
                          v-if="profile.role == 1"
                        >
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="share"
                            /><span class="action">remove admin</span>
                          </div>
                        </v-col> -->
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <div class="action_item">
                            <font-awesome-icon class="action-icon" icon="eye" />
                            <span
                              class="action"
                              @click="addToTeam(item)"
                              v-if="item.team.id == ''"
                              >add to team</span
                            >
                            <span
                              class="action"
                              @click="removeFromTeam(item)"
                              v-else
                              >remove from team</span
                            >
                          </div>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="pencil-alt"
                            /><span
                              class="action"
                              @click="editUserAccount(item)"
                              >edit account</span
                            >
                          </div>
                          <v-dialog v-model="editUserDialog" max-width="500px">
                            <v-card class="modal">
                              <v-card-title>
                                <span class="headline">Edit Account</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <v-form
                                    v-model="editUserFormValid"
                                    ref="editUserForm"
                                    lazy-validation
                                  >
                                    <v-row>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedUser.fullname"
                                          label="Full Name"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedUser.title"
                                          label="Title"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        v-if="profile.role == 1"
                                      >
                                        <v-autocomplete
                                          v-model="editedUser.team"
                                          label="Team"
                                          :rules="fieldRules"
                                          :items="teams"
                                          required
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedUser.address"
                                          label="Address"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedUser.country"
                                          label="Country"
                                          :rules="fieldRules"
                                          :items="countries"
                                          item-text="name"
                                          item-value="id"
                                          return-object
                                          required
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedUser.language"
                                          label="Language"
                                          :rules="fieldRules"
                                          :items="languageOptions"
                                          item-text="name"
                                          item-value="id"
                                          return-object
                                          required
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedUser.timezone"
                                          label="Timezone"
                                          :rules="fieldRules"
                                          :items="timezoneOptions"
                                          item-text="name"
                                          item-value="id"
                                          return-object
                                          required
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="12">
                                        <v-radio-group
                                          v-model="editedUser.gender"
                                          row
                                          label="Gender"
                                          class="d-flex justify-content-sm-between"
                                          required
                                        >
                                          <v-radio
                                            label="Male"
                                            :value="0"
                                            color="#5f6f85"
                                          ></v-radio>
                                          <v-radio
                                            label="Female"
                                            :value="1"
                                            color="#5f6f85"
                                          ></v-radio>
                                          <v-radio
                                            label="Unspecified"
                                            :value="2"
                                            color="#5f6f85"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-form>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn class="save" text @click="editUserSave"
                                  >Save</v-btn
                                >
                                <v-btn
                                  class="cancel"
                                  text
                                  @click="editUserClose"
                                  >Cancel</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <delete-account v-bind:item="item"></delete-account>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template v-slot:item.image>
                <img
                  src="/assets/images/myprofile.png"
                  alt=""
                  width="49px"
                  height="49px"
                  class="image"
                />
              </template>
              <template v-slot:item.fullname="{ item }">
                <div class="original">
                  <div class="fullname">
                    <span class="bold">Full name</span
                    ><span>{{ item.fullname }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold">Team</span
                    ><span>{{ item.team.name }}</span>
                  </div>
                </div>
                <div class="additional">
                  <div class="fullname">
                    <span class="bold">Last login</span
                    ><span>{{ item.lastlogin }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"># of uploaded config files</span
                    ><span>{{ item.configfiles }}</span>
                  </div>
                </div>
              </template>
              <template v-slot:item.emailphone="{ item }">
                <div class="original">
                  <div class="fullname">
                    <span class="bold">Email</span><span>{{ item.email }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold">Phone</span><span>{{ item.phone }}</span>
                  </div>
                </div>
                <div class="additional">
                  <div class="fullname">
                    <span class="bold"># of vulnerabilities hunted</span
                    ><span>{{ item.hunted }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"
                      ># of critical vulnerabilities hunted</span
                    ><span>{{ item.critical_hunted }}</span>
                  </div>
                </div>
                <div class="collapse_icon">
                  <font-awesome-icon
                    class="report"
                    icon="ellipsis-h"
                    @click="expandOnMobile"
                  />
                </div>
              </template>
              <template v-slot:item.loginconfig="{ item }">
                <div class="fullname">
                  <span class="bold">Last login</span
                  ><span>{{ item.lastlogin }}</span>
                </div>
                <div class="fullname">
                  <span class="bold"># of uploaded config files</span
                  ><span>{{ item.configfiles }}</span>
                </div>
              </template>
              <template v-slot:item.hunted="{ item }">
                <div class="fullname">
                  <span class="bold"># of vulnerabilities hunted</span
                  ><span>{{ item.hunted }}</span>
                </div>
                <div class="fullname">
                  <span class="bold"># of critical vulnerabilities hunted</span
                  ><span>{{ item.critical_hunted }}</span>
                </div>
              </template>
              <template v-slot:item.report="{ item }">
                <font-awesome-icon
                  class="report"
                  icon="ellipsis-h"
                  @click="expandOnDesktop"
                />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-text v-if="this.showactiveteam == true">
            <v-row class="table_control" v-if="this.showtablecontrol == true">
              <v-col cols="12" sm="3" md="3" lg="3">
                <v-autocomplete
                  v-model="bulkaction"
                  label="Bulk actions"
                  :rules="fieldRules"
                  :items="bulkactions"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" md="1" lg="1" class="control_button">
                <v-btn color="white">COMMIT</v-btn>
              </v-col>
              <v-col cols="12" sm="2" md="3" lg="3">
                <v-autocomplete
                  v-model="sortBy"
                  label="Sort by"
                  :rules="fieldRules"
                  :items="sortbyOptions"
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-data-table
              v-model="selected"
              :single-select="singleSelect"
              :headers="headers"
              :items="activeteams"
              :hide-default-header="true"
              :hide-default-footer="true"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              item-key="id"
              show-expand
              show-select
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="12" sm="3" md="2" lg="2">
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold">Company</span
                            ><span>{{ item.company }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold">Title</span
                            ><span>{{ item.title }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <div class="expanded_item">
                            <v-autocomplete
                              v-model="item.role"
                              label="regular user"
                              :rules="fieldRules"
                              :items="users"
                              required
                            ></v-autocomplete>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="9" md="6" lg="6">
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold address">Address</span
                            ><span>{{ item.address }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4">
                          <div class="expanded_item">
                            <span class="bold">Language</span
                            ><span class="language">{{ item.language }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="8" lg="8">
                          <div class="expanded_item">
                            <span class="bold">Timezone</span
                            ><span>{{ item.timezone }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="12" lg="12">
                          <div class="expanded_item">
                            <span class="bold">Gender</span
                            ><span>{{ item.gender }}</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-row>
                        <v-col cols="12" sm="3" md="6" lg="6" class="change">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="hashtag"
                            /><span class="action">change password</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="pause"
                            /><span class="action">pause account</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6" class="remove">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="share"
                            /><span class="action">remove admin</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="eye"
                            /><span class="action">add to team</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="pencil-alt"
                            /><span class="action" @click="EditAccount(item)"
                              >edit account</span
                            >
                          </div>
                          <v-dialog v-model="accountdialog" max-width="500px">
                            <v-card>
                              <v-card-title>
                                <span class="headline">Edit Team</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                        v-model="editedItem.fullname"
                                        label="Full Name"
                                        :rules="fieldRules"
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                        v-model="editedItem.email"
                                        label="Email"
                                        :rules="fieldRules"
                                        type="email"
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                        v-model="editedItem.phone"
                                        label="Phone"
                                        type="text"
                                        v-mask="'(###) ###-####'"
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                        v-model="editedItem.company"
                                        label="Company"
                                        :rules="fieldRules"
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-text-field
                                        v-model="editedItem.address"
                                        label="Address"
                                        :rules="fieldRules"
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                        v-model="editedItem.title"
                                        label="Title"
                                        :rules="fieldRules"
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-autocomplete
                                        v-model="editedItem.language"
                                        label="Language"
                                        :rules="fieldRules"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        :items="languageOptions"
                                        required
                                      ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-autocomplete
                                        v-model="editedItem.timezone"
                                        label="Timezone"
                                        :rules="fieldRules"
                                        :items="timezoneOptions"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        required
                                      >
                                      </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-radio-group
                                        v-model="editedItem.gender"
                                        label="Gender"
                                        row
                                        class="d-flex justify-content-sm-between"
                                        :rules="fieldRules"
                                        required
                                      >
                                        <v-radio
                                          label="Male"
                                          value="male"
                                          color="#5f6f85"
                                        ></v-radio>
                                        <v-radio
                                          label="Female"
                                          value="female"
                                          color="#5f6f85"
                                        ></v-radio>
                                        <v-radio
                                          label="Unspecified"
                                          value="unspecified"
                                          color="#5f6f85"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <div class="flex-grow-1"></div>
                                <v-btn class="cancel" text @click="close"
                                  >Cancel</v-btn
                                >
                                <v-btn class="save" text @click="save"
                                  >Save</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="3" md="6" lg="6">
                          <div class="action_item">
                            <font-awesome-icon
                              class="action-icon"
                              icon="trash-alt"
                            /><span class="delete">delete account</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template v-slot:item.image class="image">
                <img
                  src="/assets/images/myprofile.png"
                  alt=""
                  width="49px"
                  height="49px"
                />
              </template>
              <template v-slot:item.fullname="{ item }">
                <div class="original">
                  <div class="fullname">
                    <span class="bold">Full name</span
                    ><span>{{ item.fullname }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold">Team</span><span>{{ item.team }}</span>
                  </div>
                </div>
                <div class="additional">
                  <div class="fullname">
                    <span class="bold">Last login</span
                    ><span>{{ item.lastlogin }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"># of uploaded config files</span
                    ><span>{{ item.configfiles }}</span>
                  </div>
                </div>
              </template>
              <template v-slot:item.emailphone="{ item }">
                <div class="original">
                  <div class="fullname">
                    <span class="bold">Email</span><span>{{ item.email }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold">Phone</span><span>{{ item.phone }}</span>
                  </div>
                </div>
                <div class="additional">
                  <div class="fullname">
                    <span class="bold"># of vulnerabilities hunted</span
                    ><span>{{ item.hunted }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"
                      ># of critical vulnerabilities hunted</span
                    ><span>{{ item.critical_hunted }}</span>
                  </div>
                </div>
                <div class="collapse_icon">
                  <font-awesome-icon
                    class="report"
                    icon="ellipsis-h"
                    @click="expandOnMobile"
                  />
                </div>
              </template>
              <template v-slot:item.loginconfig="{ item }">
                <div class="fullname">
                  <span class="bold">Last login</span
                  ><span>{{ item.lastlogin }}</span>
                </div>
                <div class="fullname">
                  <span class="bold"># of uploaded config files</span
                  ><span>{{ item.configfiles }}</span>
                </div>
              </template>
              <template v-slot:item.hunted="{ item }">
                <div class="fullname">
                  <span class="bold"># of vulnerabilities hunted</span
                  ><span>{{ item.hunted }}</span>
                </div>
                <div class="fullname">
                  <span class="bold"># of critical vulnerabilities hunted</span
                  ><span>{{ item.critical_hunted }}</span>
                </div>
              </template>
              <template v-slot:item.report>
                <font-awesome-icon
                  class="report"
                  icon="ellipsis-h"
                  show-expand
                  @click="expandOnDesktop"
                />
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-card-text>
  </fragment>
</template>

<script>
import Vue from "vue";
import InviteUsers from "./InviteUsers";
import CreateTeam from "./CreateTeam";
import DeleteTeam from "./DeleteTeam";
import DeleteAccount from "./DeleteAccount";
Vue.component("invite-users", InviteUsers);
Vue.component("create-team", CreateTeam);
Vue.component("delete-team", DeleteTeam);
Vue.component("delete-account", DeleteAccount);

export default {
  components: {
    InviteUsers,
    CreateTeam,
    DeleteTeam,
    DeleteAccount
  },
  computed: {
    profile() {
      return this.$store.state.user.profile;
    },
    timezoneOptions() {
      return this.$store.getters.timezones;
    },
    languageOptions() {
      return this.$store.getters.languages;
    },
    countries() {
      return this.$store.getters.countries;
    },
    allusers() {
      return this.$store.state.identity.allusers;
    },
    adminteams() {
      return this.$store.state.identity.allteams;
    }
  },

  data() {
    return {
      fieldRules: [v => !!v || "Required"],
      passwordRules: [
        v => !!v || "This field is Required",
        v =>
          /(?=.*[a-z])/.test(v) ||
          "Must contain at least 1 lowercase alphabetical character",
        v =>
          /(?=.*[A-Z])/.test(v) ||
          "Must contain at least 1 uppercase alphabetical character",
        v =>
          /(?=.*[0-9])/.test(v) || "Must contain at least 1 numeric character",
        v =>
          /(?=.[!@#\$%\^&])/.test(v) ||
          "Must contain at least one special character",
        v => /(?=.{8,})/.test(v) || "Must be eight characters or longer"
      ],

      teamManager: {
        id: "",
        name: "",
        users: []
      },
      bulkaction: "",
      bulkactions: [
        // "Change Password",
        "Pause Account",
        "Remove from team",
        "Delete Account"
      ],
      chooseError: false,
      assginteam: "",
      sortBy: "",
      sortbyOptions: [
        { text: "Full Name", value: "fullname" },
        { text: "Company", value: "company" },
        { text: "Team", value: "team" }
      ],
      users: [
        { text: "Super Admin", value: 1 },
        { text: "Team Admin", value: 2 },
        { text: "Normal User", value: 3 },
        { text: "View Only User", value: 4 }
      ],
      headers: [
        { text: "IMAGE", align: "center", sortable: false, value: "image" },
        {
          text: "Full Name",
          align: "left",
          sortable: false,
          value: "fullname"
        },
        {
          text: "Eamil & Phone",
          align: "left",
          sortable: false,
          value: "emailphone"
        },
        {
          text: "Login & Config",
          align: "left",
          sortable: false,
          value: "loginconfig"
        },
        { text: "Hunted", align: "left", sortable: false, value: "hunted" },
        { text: "REPORT", align: "left", sortable: false, value: "report" },
        { text: "Team", align: "left", sortable: false, value: "team" },
        { text: "Company", align: "left", sortable: false, value: "company" }
      ],
      items: [],
      selected: [],
      singleSelect: false,
      expanded: [],
      singleExpand: true,
      showeditprofilepage: false,
      showmyteams: true,
      showtablecontrol: true,
      showallusers: true,
      showactiveteam: false,
      search: "",

      activeteams: [],

      valid: false,

      teams: [],

      changeUserPwdFormValid: false,
      editUserDialog: false,
      editedUser: {},
      editUserFormValid: false,

      userpwdchangedialog: false,
      usernewpwd: "",
      usernewpwdconfirm: "",
      userpwdchangestatus: {
        status: 0,
        text: ""
      }      
    };
  },
  methods: {
    expandOnDesktop(event) {
      let parent_row =
        event.target.tagName == "svg"
          ? event.target.parentElement.parentElement
          : event.target.parentElement.parentElement.parentElement;
      parent_row.firstElementChild.firstElementChild.click();
    },
    expandOnMobile() {
      let parent_row =
        event.target.tagName == "svg"
          ? event.target.parentElement.parentElement.parentElement.parentElement
              .parentElement
          : event.target.parentElement.parentElement.parentElement.parentElement
              .parentElement.parentElement;
      parent_row.firstElementChild.firstElementChild.lastElementChild.firstElementChild.click();
    },
    ShowMyTeams() {
      this.showmyteams = this.showmyteams == true ? false : true;
      if (this.showmyteams == true) {
        let itag = document.querySelector(
          "#team .card.v-card .v-card__title .down-arrow"
        );
        itag.style.transform = "rotate(180deg)";
        itag.style.transition = "all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      } else {
        let itag = document.querySelector(
          "#team .card.v-card .v-card__title .down-arrow"
        );
        itag.style.transform = "none";
        itag.style.transition = "all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      }
    },
    ShowTableControl() {
      this.showtablecontrol = this.showtablecontrol == true ? false : true;
      if (this.showtablecontrol == true) {
        let itag = document.querySelector(
          ".useraccount .v-card .v-card__title .down-arrow"
        );
        itag.style.transform = "rotate(180deg)";
        itag.style.transition = "all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      } else {
        let itag = document.querySelector(
          ".useraccount .v-card .v-card__title .down-arrow"
        );
        itag.style.transform = "none";
        itag.style.transition = "all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      }
    },
    ShowAllUsers() {
      this.showallusers = true;
      this.showactiveteam = false;
    },
    ShowActiveTeam() {
      this.showactiveteam = true;
      this.showallusers = false;
    },
    assignTeam() {
    },

    changeUserPwd(item) {
      if (!this.$refs.changeUserPwdForm.validate()) {
        return;
      }
      if (this.usernewpwd != this.usernewpwdconfirm) {
        this.userpwdchangestatus = {
          status: -1,
          text: "Confirm Password does not Match"
        };
        return;
      }
      const data = {
        user_id: item.id,
        password: this.usernewpwd
      };
      this.$store
        .dispatch("changeUserPwd", data)
        .then(() => {
          this.userpwdchangestatus = {
            status: 1,
            text: "Password Changed Successfully"
          };
        })
        .catch(() => {
          this.userpwdchangestatus = {
            status: -1,
            text: "Error. Please try again"
          };
        });
    },
    pauseAccount(item) {
      const data = { user_id: item.id };
      this.$store
        .dispatch("pauseUserAccount", data)
        .then(() => {})
        .catch(error => {
        });
    },
    addToTeam(item) {
      if (this.assginteam == "") {
        this.chooseError = true;
        return;
      }
      const data = {
        user_id: item.id,
        team_id: this.assginteam.id
      };
      this.$store
        .dispatch("addUserToTeam", data)
        .then(() => {})
        .catch(error => {
        });
    },
    removeFromTeam(item) {
      const data = { user_id: item.id };
      this.$store
        .dispatch("removeUserFromTeam", data)
        .then(() => {})
        .catch(error => {
        });
    },
    editUserAccount(item) {
      this.editedUser = Object.assign({}, item);
      this.editUserDialog = true;
    },
    editUserClose() {
      this.editUserDialog = false;
      this.editedUser = {};
    },
    editUserSave() {
      if (!this.$refs.editUserForm.validate()) {
        return;
      }
      const data = {
        user_id: this.editedUser.id,
        fullname: this.editedUser.fullname,
        gender: this.editedUser.gender,
        title: this.editedUser.title,
        address: this.editedUser.address,
        country: this.editedUser.country.id,
        language: this.editedUser.language.id,
        timezone: this.editedUser.timezone.id
      };
      this.$store
        .dispatch("editUserAccount", data)
        .then(() => {
          this.editUserClose();
        })
        .catch(error => {
        });
    },
    changeUserRole(item) {
      const data = {
        user_id: item.id,
        role: item.role
      };
      this.$store.dispatch("editUserAccount", data);
    },
    bulkCommit() {
      this.selected.forEach(item => {
        if (this.bulkaction == "Pause Account") {
          this.pauseAccount(item);
        } else if(this.bulkaction == "Remove from team") {
          this.removeFromTeam(item);
        } else if (this.bulkaction == "Delete Account") {
          this.$store.dispatch("deleteAccount", {user_id: item.id}).then(() => {
            this.$store.dispatch("getAllUsers");
          });
        }
      });
    }
  }
};
</script>
